import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getPaymentType = (state: StateScheme) => {
    return state.payment.type
}
